<template lang="html">
  <div>

    <section class="idioma">
      <span @click="show = !show">{{lang}}</span>
      <template v-if="show">
        <button @click="langselected = 'ca'" :active="lang == 'ca'">CA</button>
        <button @click="langselected = 'es'" :active="lang == 'es'">ES</button>
      </template>
    </section>

    <div class="cover-popup row-center" v-if="langselected">
      <div class="popup">
        <p>{{$t('popup_idioma.titulo')}}</p>
        <div class="contenedor-botones row-center">
          <button @click="requestLangChange" class="btn -solid-primary">{{$t('registro.si')}}</button>
          <button @click="langselected = ''" class="btn -skull-primary">{{$t('registro.no')}}</button>
        </div>
      </div>
    </div>

  </div>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'idioma',
    data: () => ({
      show: false,
      langselected: ''
    }),
    methods: {
      ...mapActions(['changeLanguage']),
      requestLangChange() {
        this.changeLanguage(this.langselected).then(() => {
          this.langselected = '';
          this.show = false;
        });
      },
    },
    computed: {
      ...mapGetters({
        lang: 'getLanguage'
      })
    }
  }
</script>

<style scoped lang="scss">
  .idioma {
    margin-left: 10px;
    display: flex;
    position: relative;
    width: 30px;
    height: 25px;
    margin-right: 15px;

    span {
      text-transform: uppercase;
      height: 25px;
      line-height: 25px;
      cursor: pointer;
      width: 100%;
      background: url(/static/img/icons/down-arrow-blue.svg) center right/10px no-repeat;
      display: inline-block;
      text-align: left;
    }

    button {
      background: #709194;
      border: none;
      text-transform: uppercase;
      font-size: 16px;
      cursor: pointer;
      position: absolute;
      left: -7px;
      height: 25px;
      width: 30px;
      

      &:last-child {
        border: none;
      }
    }


    @for $i from 1 through 4 {

      button:nth-of-type(#{$i}) {
        top:calc(#{$i} * 25px);
      }
    }

  }


  .popup {
    min-height: 150px;
  }

  .popup p {
    width: 100%;
    text-align: left;
    font-weight: bold;
    color: black;
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/idioma-header.vue